import { Layout, Menu } from 'antd';
import { MenuProps } from 'antd/lib';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import collapsedLogo from '../assets/Orino-small.png';
import logo from '../assets/Orino.png';
import findItemByKey from '../helpers/findItemByKey';
import findSelectedKeys from '../helpers/findSelectedKeys';

import classes from './SidebarLayout.module.css';

const { Sider } = Layout;

export default function SidebarLayout({
  items,
}: {
  items: {
    key: string;
    url?: string;
    icon?: React.ReactNode;
    label: string | React.ReactNode;
    children?: any[];
    permissions?: any[];
    requireOwner?: boolean;
    requireSuperAdmin?: boolean;
    isLocked?: boolean;
    upgradeUrl?: string;
  }[];
}) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const url = window.location.pathname;

  const handleMenuItemSelect: MenuProps['onSelect'] = (e) => {
    const selectedItem = findItemByKey(e.key, items);

    if (!selectedItem) console.error('selectedItem not found');

    // Check if the item is locked
    if (selectedItem?.isLocked) {
      return;
    }

    // navigate to the selected item url
    if (selectedItem?.url) {
      navigate(selectedItem.url);
    }
  };

  const selectedKeys = findSelectedKeys(url, items);

  return (
    <Sider
      className={classes.sidebar}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      theme="light"
      width={250}
      style={{
        backgroundColor: 'var(--bg-clr)',
      }}
    >
      <div className={classes.logoContainer}>
        <img className={classes.logo} src={collapsed ? collapsedLogo : logo} alt="Orino" />
      </div>
      <Menu
        mode="inline"
        items={items.map((item) => ({
          ...item,
          className: item.isLocked
            ? `${classes.menuItem} ${classes.lockedMenuItem}`
            : classes.menuItem,
        }))}
        onSelect={handleMenuItemSelect}
        selectedKeys={selectedKeys}
        style={{
          backgroundColor: 'var(--bg-clr)',
          border: 'none',
        }}
      />
    </Sider>
  );
}
